export const promptOptions = [
  {
    id: 1,
    label: 'Write a tweet',
    value: 'Write a tweet for',
  },
  {
    id: 2,
    label: 'Generate content calendar',
    value: 'Create a content calendar for ',
  },
  // {
  //   id: 3,
  //   label: 'Summarize',
  //   value: 'Summarize the following: ',
  // },
  {
    id: 4,
    label: 'Translate',
    value: 'Translate into English: ',
  },
  {
    id: 5,
    label: 'Fix grammar',
    value: 'Fix grammar for: ',
  },
  {
    id: 6,
    label: 'Explain this',
    value: 'Explain this: ',
  },
  {
    id: 7,
    label: 'Improve writing',
    value: 'Improve writing for: ',
  },
  {
    id: 8,
    label: 'Write a sales email',
    value: 'Write a sales email for: ',
  },
  {
    id: 9,
    label: 'Create product sales copy',
    value: 'Write a product sales copy for: ',
  },
  {
    id: 10,
    label: 'Write social copy',
    value: 'Write social copy for: ',
  },
  {
    id: 11,
    label: 'Brainstorm ideas',
    value: 'Generate brainstorm ideas for: ',
  },
  {
    id: 12,
    label: 'Write an essay',
    value: 'Write an essay on: ',
  },
  {
    id: 13,
    label: 'Make a pros and cons list',
    value: 'Generate a pros and cons list for: ',
  },
  {
    id: 14,
    label: 'Generate a creative story',
    value: 'Write a a creative story on: ',
  },
];
